<template>
  <section class="done" v-if="tasks">
    <div class="d-flex flex-column container" ref="actionsDone">
      <template v-for="(task,index) in tasks">
        <div
          class="card task"
          v-if="((index<(max*page) && $mq!=='sm' && $mq!=='md') || ($mq==='sm' || $mq==='md' ))"
          :key="index"
          :class="[task.type.replace('.','-')]"
        >
          <div class="card-body p-0 m-0 d-flex flex-column flex-md-row align-items-center">
            <div class="row align-items-center w-100">
              <div class="col-7 col-md-9 description">
                <div class="row p-0">
                  <div class="col-12 col-md-2 text-left text-md-center text-primary points p-0">
                    <strong
                      v-if="(task.coins!==0) || task.type==='answer.instawin'"
                    >{{(task.coins>0)?'+':null}}{{task.coins}} {{$t('points')}}</strong>
                  </div>
                  <div class="col-12 col-md-10 p-0">
                    <strong
                      v-if="getLabelIndex(task.type).indexOf('tenants.actionsnew.answer.question') !== -1"
                    >{{$t('tenants.actionsnew.answer.question')}}</strong>
                    <strong
                      v-else-if="task.type === 'game.card.store'"
                    >{{$t('Giocato al gioco delle coppie')}}</strong>
                    <strong
                      v-else-if="getLabelIndex(task.type).indexOf('store') !== -1"
                    >{{$t('tenants.actionsnew.external.download.store')}}</strong>
                    <strong
                      v-else
                      id="typeDone"
                    >{{ $t(getLabelIndex(task.type)).charAt(0).toUpperCase() + $t(getLabelIndex(task.type)).slice(1) }}</strong>
                  </div>
                </div>
              </div>
              <div
                class="col-5 col-md-3 text-center"
              >{{ task.createdAt | moment("DD/M/YYYY HH:mm") }}</div>
            </div>
          </div>
        </div>
      </template>
      <div
        class="moreActions text-center"
        v-if="tasks && ($mq!=='sm' && $mq!=='md' ) && tasks.length>(max*page)"
      >
        <a :href="moreactions" v-if="!paginated" class="a-more btn-not-spinner">{{$t('Show More')}}</a>
        <a href="#" @click="addPage" v-else class="a-more btn-not-spinner">{{$t('Show More')}}</a>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  components: {},
  props: {
    tasks: { default: null },
    moreactions: { default: "#" },
    max: { default: 3 },
    paginated: { default: false }
  },
  computed: {},
  data() {
    return {
      pointer: 0,
      page: 1
    };
  },
  methods: {
    addPage(e) {
      if (e) e.preventDefault();
      if (this.tasks && this.tasks.length > this.max * this.page) this.page++;
    },
    getLabelIndex(type) {
      let newType = type;

      if (type.indexOf("survey") !== -1) {
        newType = newType.split(".");
        newType.pop();
        newType = newType.join(".");
      }

      return "tenants.actionsnew." + newType;
    }
  }
};
</script>
<style scoped>
.card.task .description {
}
strong {
  font-weight: bold;
}
</style>